/*
 * Rabattcode-Feld im Warenkorb.
 *
 * Shopify's Ajax cart API has no endpoint for applying a discount code, so
 * this sends the visitor through /discount/<code>, which applies the code to
 * their session and redirects straight back. The cart then re-renders with
 * the discount already in its totals — which is also what lets the "Du
 * sparst" line pick the code up without any separate arithmetic.
 *
 * A code that does not exist, has expired, or does not apply to this cart is
 * silently ignored by Shopify: it just redirects, with no error of any kind,
 * and any previously applied code stays put. The attempted code is therefore
 * remembered across the reload and compared against what actually ended up
 * active — otherwise a failed attempt looks exactly like nothing happening.
 */
(function () {
  var TRIED_KEY = 'onhowDiscountTried';

  function remember(code) {
    try {
      sessionStorage.setItem(TRIED_KEY, code);
    } catch (error) {
      /* private mode — the redirect still works, only the error hint is lost */
    }
  }

  function takeRemembered() {
    var code = null;
    try {
      code = sessionStorage.getItem(TRIED_KEY);
      sessionStorage.removeItem(TRIED_KEY);
    } catch (error) {
      /* nothing to recover */
    }
    return code;
  }

  // Delegated: the drawer's markup is replaced wholesale every time the cart
  // updates, so a listener bound to the form itself would not survive.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest('.cart-drawer__discount-form') : null;
    if (!form) return;
    event.preventDefault();

    var input = form.querySelector('.cart-drawer__discount-input');
    var code = ((input && input.value) || '').trim();
    if (!code) {
      if (input) input.focus();
      return;
    }

    remember(code);
    var back = form.getAttribute('data-redirect') || window.location.pathname;
    window.location.href =
      '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  });

  // The redirect lands on a fresh page with the drawer shut, so the result of
  // the attempt would otherwise sit unread behind the cart icon. open() only
  // exists once cart.js has upgraded the element, which — both scripts being
  // deferred — is not guaranteed to have happened yet.
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    function go() {
      if (typeof drawer.open !== 'function') return;
      try {
        drawer.open();
      } catch (error) {
        /* the message is in the markup either way */
      }
    }

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(go);
    } else {
      go();
    }
  }

  function reportResult() {
    var tried = takeRemembered();
    if (!tried) return;

    var box = document.querySelector('[data-onhow-discount]');
    if (!box) return;

    openDrawer();

    // Comparing against the active code rather than merely checking that one
    // exists: with a code already applied, a failed attempt leaves the old one
    // in place, which would otherwise read as success.
    var active = (box.getAttribute('data-active-code') || '').trim();
    if (active && active.toLowerCase() === tried.toLowerCase()) return;

    var error = box.querySelector('.cart-drawer__discount-error');
    if (error) error.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reportResult);
  } else {
    reportResult();
  }
})();
